import styled from 'styled-components';
import { Star } from '../../assets/Star';
import { StarHalf } from '../../assets/StarHalf';
import { StarEmpty } from '../../assets/StarEmpty';
const withStarStyles = Component => styled(Component).withConfig({
  displayName: "ReviewStarsstyled__withStarStyles",
  componentId: "sc-1aste9a-0"
})(["width:", ";height:", ";vertical-align:top;"], props => props.$width, props => props.$width);
export const StyledEmptyStar = withStarStyles(StarEmpty);
export const StyledStar = withStarStyles(Star);
export const StyledHalfStar = withStarStyles(StarHalf);
export const StyledDiv = styled.div.withConfig({
  displayName: "ReviewStarsstyled__StyledDiv",
  componentId: "sc-1aste9a-1"
})(["display:grid;grid-auto-flow:column;justify-content:left;align-items:center;"]);